import React from 'react';

import {SidebarItem} from 'app/general/structures/SidebarItem';
import {PolicyProceduresSidebar} from 'app/policies/components/PolicyDetailPage/PolicyProceduresSidebar';
import {getPolicyProceduresURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPolicySerializedType} from 'sweet-types';

function ProceduresForPolicyPanelContent({
  object,
}: LeftSidebarPanelType<DetailPolicySerializedType>) {
  return <PolicyProceduresSidebar policy={object} />;
}

function ProceduresMenuButton({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<DetailPolicySerializedType>) {
  const contentType = getContentType('procedure');
  return (
    <SidebarItem
      title={contentType.pluralName}
      active={active}
      icon={contentType.icon}
      link={getPolicyProceduresURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const ProceduresForPolicyLeftSidebar: LeftSidebarElementType<DetailPolicySerializedType> =
  {
    Panel: ProceduresForPolicyPanelContent,
    MenuButton: ProceduresMenuButton,
    type: 'left',
    sidebarName: 'showProcedures',
  };
